module.exports = __webpack_public_path__ + "img/search.34c769cd.png";